import React from 'react'

export const Reminder = () =>
  <p className='napomena-slike'>
    <strong>NAPOMENA: </strong>
    Fotografišite predmet koji prodajte, jer nije dozvoljeno postavljati fotografije sa interneta ili fotografije iz
    oglasa drugih korisnika. Takvi oglasi neće biti objavljeni.
  </p>
